import styled from 'styled-components'

const Form = styled.form`
    display: flex;
    width: ${props => props.width ? props.width : `80%`};
    flex-direction:${props => props.row ? 'row' : 'column'};    
    div.form_container{
        input {
            background-color: ${props => props.theme.bg};
            color: ${props => props.theme.title};
        }
        margin-top: .75rem;
        svg {
            width: 1rem;
            height: 1rem;
        }
        
        
        .input_border{
            border-radius: 5px;
            border-color:${props => props.color ? props.color : props.theme.primary};
            +input{
                border-radius: 5px;
                padding: .7rem .875rem;
            }
        }
    }
    .flex-end {
        display: flex;
        justify-content: flex-end;
    }
    
    
    
    >button, >button:hover{
        &+ button{
            margin-left: 1rem;
        }
        margin-top: 1.5rem;
    }
    >button.mini{
        width: fit-content;
        height: 32px;
        padding: 0 2rem;
    }
    >button.transparent{
        background-color:transparent;
        border: 1px solid ${props => props.color ? props.color : props.theme.primary} ;
        color: ${props => props.color ? props.color : props.theme.primary};
        transition: color .4s, background-color .4s;
        &:hover {
            color: ${props => props.theme.bg};
            background-color: ${props => props.color ? props.color : props.theme.primary};
        }
    }
       
`

export default Form